import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyOtaAccommodationsConsole = loadable(
  () => import(/* webpackChunkName: "content/accommodations/ota-console" */ './OtaAccommodationsConsole'),
  'OtaAccommodationsConsole',
);
